module.exports = __webpack_public_path__ + "img/sales Line.b33b4e3a.svg";